import Icon from "../Icon/Icon";
import Textfield, { TextFieldProps } from "./Textfield";

interface SearchProps extends TextFieldProps {
  onDeleteClick: () => void;
}

const Search = ({ onDeleteClick, ...props }: SearchProps) => {
  return (
    <div className="w-full relative">
      <Textfield {...props} />
      {props.value !== "" && (
        <div onClick={onDeleteClick} className="absolute top-1/2 z-4 flex -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center" style={{ right: props.inputRightAddon ? "5rem" : "1rem" }}>
          <Icon className="h-6 w-6 fill-error" variants="times" />
        </div>
      )}
    </div>
  );
};

export default Search;
